import "../App.css";
import "./Navbar.css";
import {Link} from "react-router-dom";
import { useState } from "react";

const Navbar = () =>{
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    return(
        <nav className={click ? "navbar open" : "navbar"}>
            <div className="overlay"></div>
            <div className="navbar-container">
                <div className="header-logo">
                    <h1>Justína n.o.</h1>
                </div>
                <div className="menu-icon" onClick={handleClick}>
                    <i className={click ? "fas fa-times" : "fas fa-bars"} />
                </div>

                <ul className="nav-menu">
                    <li className="nav-item">
                        <Link to="/" className="nav-link">
                            <i className="fas fa-home"></i>
                        </Link>  
                    </li>
                    <li className="nav-item">
                        <Link to="/Service" className="nav-link">Služby</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Documents" className="nav-link">Na stiahnutie</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Contact" className="nav-link">Kontakt</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/Gallery" className="nav-link">Fotogaléria</Link>
                    </li>
                    <li className="nav-item">
                        <a href="../index.html" className="nav-link">Úvod</a>
                    </li>
                </ul>
            </div>
            <div className="mobile-menu">
                <Link to="/" onClick={closeMobileMenu}>Domov</Link>
                <Link to="/Service" onClick={closeMobileMenu}>Služby</Link>
                <Link to="/Documents" onClick={closeMobileMenu}>Na stiahnutie</Link>
                <Link to="/Contact" onClick={closeMobileMenu}>Kontakt</Link>
                <Link to="/Gallery" onClick={closeMobileMenu}>Fotogaléria</Link>
                <a href="../index.html" onClick={closeMobileMenu}>Úvod</a>
            </div>
        </nav>
    )
}

export default Navbar